import React from "react";
import FormExperienceList from "./FormExperienceList";
import TextInput from "./element/TextInput";
import AddButton from "./element/AddButton";
import DeleteButton from "./element/DeleteButton";

function FormExperience({
  itemId,
  experience,
  experienceId,
  updateData,
  addData,
  removeData,
}) {
  function handleChange(e) {
    updateData({
      category: "experienceInfo",
      mainId: experienceId,
      subId: itemId,
      property: e.target.name,
      newValue: e.target.value,
    });
  }
  function handleAdd() {
    addData({
      category: "experienceList",
      mainId: experienceId,
      subId: itemId,
    });
  }
  function handleDelete() {
    removeData({
      category: "itemExperience",
      mainId: experienceId,
      subId: itemId,
    });
  }

  return (
    <>
      <div className="mb-4">
        {" "}
        <div className="flex mb-2 gap-4">
          <div className="">
            {" "}
            <TextInput
              labelText="Job Title:"
              inputName="jobTitle"
              inputOnChange={handleChange}
              inputValue={experience.jobTitle}
            />
            <TextInput
              labelText="Company:"
              inputName="companyName"
              inputOnChange={handleChange}
              inputValue={experience.companyName}
            />
            <TextInput
              labelText="Location:"
              inputName="location"
              inputOnChange={handleChange}
              inputValue={experience.location}
            />
            <TextInput
              labelText="Year Start:"
              inputName="yearStart"
              inputOnChange={handleChange}
              inputValue={experience.yearStart}
            />
            <TextInput
              labelText="Year End:"
              inputName="yearEnd"
              inputOnChange={handleChange}
              inputValue={experience.yearEnd}
            />
            <div className="flex">
              {" "}
              <label htmlFor="jobSummary">Summary:</label>
              <textarea
                className="border h-32 mb-2 xl:w-64 2xl:w-80 lg:w-48 w-100 border-slate-200 rounded-sm w-80 justify-start px-2 py-0.5 hover:border-slate-400 focus:border-slate-700 transition outline-0"
                type="text"
                name="jobSummary"
                onChange={handleChange}
                defaultValue={experience.jobSummary}
              />
            </div>
            {experience.jobDetails.map((detailsItem, index) => {
              return (
                <FormExperienceList
                  key={detailsItem.id}
                  experienceId={experienceId}
                  itemId={itemId}
                  listItemId={index}
                  detailsItem={detailsItem}
                  updateData={updateData}
                  removeData={removeData}
                />
              );
            })}
          </div>
          <DeleteButton handleDelete={handleDelete} />
        </div>
        <AddButton handleAdd={handleAdd} text={"+ list item"} />
      </div>
    </>
  );
}

export default FormExperience;
